import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  { path: '/', name: 'Guest', meta: { name: 'Cursor页面' }, component: () => import('../views/Guest.vue') },
  { path: '/windsurf', name: 'Windsurf', meta: { name: 'Windsurf页面' }, component: () => import('../views/Windsurf.vue') },
  { path: '/kiro', name: 'Kiro', meta: { name: 'Kiro页面' }, component: () => import('../views/Kiro.vue') },
  { path: '/zencoder', name: 'Zencoder', meta: { name: 'Zencoder页面' }, component: () => import('../views/Zencoder.vue') },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 注：不需要前台的项目，可以注释掉该路由守卫
// 路由守卫
router.beforeEach((to ,from, next) => {
  // 游客页面不需要验证权限，直接放行
  if (to.path === '/' || to.path === '/windsurf' || to.path === '/kiro' || to.path === '/zencoder') {
    next();
  }
})

export default router
